<script setup lang="ts">
/**
 * InnovationSection —— 单卡 = 一个 `.scu-grid-item`（2026-06-25 R1/R6）。
 *
 * 模板「创新点」= 1 个 `.scu-widget` + `.scu-grid` 内 4 个 `.scu-grid-item`；
 * Vue 数据模型里 4 个创新点 = 4 个 type=innovation Section，由 F12 聚成
 * 一个 widget 区（标题 + grid 容器）。故 F05 的 InnovationSection **不**
 * 自带 widget 壳，只渲染单张 grid-item 卡片（▶ marker + h4 标题 + p
 * 摘要），F12 在外层补 widget 壳。详情正文由 DetailPage 消费
 * `bodyHtml`，首页不把富文本塞进模板卡片，避免与 `project/index.html`
 * 的卡片形态不一致。
 *
 * 根标签 `<article>`（非 `<section>`）——它是 widget 内的网格项，不是
 * 独立 widget；`data-section-type` 仍挂在根上供 Registry 定位。
 */
import GridItem from './GridItem.vue';
import type { SectionComponentProps } from './section-props';

const props = defineProps<SectionComponentProps>();
</script>

<template>
  <GridItem
    :id="props.id"
    :class="$style.card"
    :data-section-type="props.section.type"
    :title="props.section.title"
    :summary="props.section.summary"
    :show-draft-badge="props.showDraftBadge"
  >
  </GridItem>
</template>

<style module>
.card {
  height: 100%;
}
</style>
